import type { Ref } from 'vue'
import type { BrowseFacetDTO } from '../models'
import type { BrowseFacetService, BrowseFacetServiceListParams } from '../services/interfaces'
import { ref } from 'vue'
import { CONTAINER } from '../config/inversify.config'
import { TYPES } from '../config/inversify.types'

export interface BrowseFacetComposable {
  facets: Ref<Array<BrowseFacetDTO>>
  loading: Ref<boolean>
  list: (params: BrowseFacetServiceListParams) => Promise<Array<BrowseFacetDTO>>
}

export function useBrowseFacet(): BrowseFacetComposable {
  const service = CONTAINER.get<BrowseFacetService>(TYPES.BrowseFacetService)

  const listHistory: Record<string, Array<BrowseFacetDTO>> = {}

  const facets = ref<Array<BrowseFacetDTO>>([])

  const loading = ref(false)

  async function list(params: BrowseFacetServiceListParams): Promise<Array<BrowseFacetDTO>> {
    const paramsKey = getListParamsKey(params)
    if (!listHistory.hasOwnProperty(paramsKey)) {
      loading.value = true
      try {
        listHistory[paramsKey] = await service.list(params)
      } catch (error) {
        facets.value = []
        throw error
      } finally {
        loading.value = false
      }
    }
    return (facets.value = listHistory[paramsKey])
  }

  return {
    facets,
    loading,
    list,
  }
}

function getListParamsKey(params: BrowseFacetServiceListParams): string {
  return [
    `field=${params.field}`,
    `value=${params.value}`,
    params.pivots
      .reduce<Array<string>>((result, pivot) => {
        if (pivot.values.length) {
          result.push(`${pivot.name}=${pivot.values.sort().join(',')}`)
        }
        return result
      }, [])
      .sort(),
  ].join('&')
}
